import React, { useEffect } from 'react';
import { Form } from 'formik';
import FormInput from '../common/FormInput.tsx';
import MapComponent from '../common/map/GoogleMap.tsx';
import RequiredLabel from '../common/RequiredLabel.tsx';

const ClientForm = ({ handleChange, values, touched, errors, setFieldValue }) => {
  useEffect(() => {
    if (values && Object.keys(values).length > 0) {
      Object.entries(values).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          setFieldValue(key, value);
        }
      });
    }
  }, [values, setFieldValue]);

  return (
    <Form>
      <p className='text-[#0F44BE] mb-3'>CLIENT INFORMATION</p>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <RequiredLabel>First Name</RequiredLabel>
          <FormInput
            name="firstname"
            type="text"
            placeholder="Enter first Name"
            onChange={handleChange}
            value={values?.firstname || ''}
            error={touched?.firstname && errors?.firstname}
          />
        </div>
        <div>
          <RequiredLabel>Last Name</RequiredLabel>
          <FormInput
            name="lastname"
            type="text"
            placeholder="Enter last Name"
            onChange={handleChange}
            value={values?.lastname || ''}
            error={touched?.lastname && errors?.lastname}
          />
        </div>

      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <RequiredLabel>Email ID</RequiredLabel>
          <FormInput
            name="email"
            type="email"
            placeholder="Enter Email"
            onChange={handleChange}
            value={values.email}
            error={touched.email && typeof errors.email === 'string' ? errors.email : undefined}
          />
        </div>
        <div>
          <RequiredLabel>Mobile Number</RequiredLabel>
          <FormInput
            name="mobile"
            type="number"
            placeholder="Enter mobile Number"
            onChange={handleChange}
            value={values.mobile}
            error={touched.mobile && typeof errors.mobile === 'number' ? errors.mobile : undefined}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mt-4">

        <div>
          <RequiredLabel>Age</RequiredLabel>
          <FormInput
            name="age"
            type="number"
            placeholder="Enter Your Age"
            onChange={handleChange}
            value={values.age}
            error={touched.age && typeof errors.age === 'string' ? errors.age : undefined}
          />
        </div>
        <div>
          <RequiredLabel>Status</RequiredLabel>
          <FormInput
            name="status"
            type="text"
            placeholder="Enter Status"
            onChange={handleChange}
            value={values.status}
            error={touched.Status && typeof errors.status === 'string' ? errors.status : undefined}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mt-4">

        <div>
          <RequiredLabel>TFN Number</RequiredLabel>
          <FormInput
            name="TFN_number"
            type="text"
            placeholder="Enter Your TFN Number"
            onChange={handleChange}
            value={values.TFN_number}
            error={touched.TFN_number && typeof errors.TFN_number === 'string' ? errors.TFN_number : undefined}
          />
        </div>
        <div>
          <RequiredLabel>License</RequiredLabel>
          <FormInput
            name="license"
            type="text"
            placeholder="Enter license"
            onChange={handleChange}
            value={values.license}
            error={touched.license && typeof errors.license === 'string' ? errors.license : undefined}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mt-4">

        <div>
          <RequiredLabel>Proof of Age</RequiredLabel>
          <FormInput
            name="proofage"
            type="text"
            placeholder="Enter Your Proof of age"
            onChange={handleChange}
            value={values.proofage}
            error={touched.proofage && typeof errors.proofage === 'string' ? errors.proofage : undefined}
          />
        </div>
        <div>
          <RequiredLabel>Passport</RequiredLabel>
          <FormInput
            name="passport"
            type="text"
            placeholder="Enter passport"
            onChange={handleChange}
            value={values.passport}
            error={touched.passport && typeof errors.passport === 'string' ? errors.passport : undefined}
          />
        </div>
      </div>

      <div className='grid grid-cols-2 gap-4 mt-4'>
        <div>
          <RequiredLabel>Selected Address</RequiredLabel>
          <FormInput
            name="address"
            type="text"
            placeholder="Enter Address"
            onChange={handleChange}
            value={values.address}
            error={touched.address && typeof errors.address === 'string' ? errors.address : undefined}
          />
        </div>
        <div>
          <RequiredLabel>City</RequiredLabel>
          <FormInput
            name="city"
            type="text"
            placeholder="Enter City"
            onChange={handleChange}
            value={values.city}
            error={touched.city && typeof errors.city === 'string' ? errors.city : undefined}
          />
        </div>
        <div className='grid grid-cols-2 gap-4 mt-4'>
          <div>
            <RequiredLabel>State</RequiredLabel>
            <FormInput
              name="state"
              type="text"
              placeholder="Enter State"
              onChange={handleChange}
              value={values.state}
              error={touched.state && typeof errors.state === 'string' ? errors.state : undefined}
            />
          </div>
          <div>
            <RequiredLabel>zipcode</RequiredLabel>
            <FormInput
              name="zipcode"
              type="text"
              placeholder="Enter zipcode"
              onChange={handleChange}
              value={values.zipcode}
              error={touched.zipcode && typeof errors.zipcode === 'string' ? errors.zipcode : undefined}
            />
          </div>
        </div>
        <div className='grid grid-cols-2 gap-4 mt-4'>
          <div>
            <RequiredLabel>Latitude</RequiredLabel>
            <FormInput
              name="latitude"
              type="text"
              placeholder="Enter Latitude"
              onChange={handleChange}
              value={values.latitude}
              error={touched.latitude && typeof errors.latitude === 'string' ? errors.latitude : undefined}
              disabled={true}
            />
          </div>
          <div>
            <RequiredLabel>Longitude</RequiredLabel>
            <FormInput
              name="longitude"
              type="text"
              placeholder="Enter Longitude"
              onChange={handleChange}
              value={values.longitude}
              error={touched.longitude && typeof errors.longitude === 'string' ? errors.longitude : undefined}
              disabled={true}
            />
          </div>
        </div>
      </div>
      <div className='mt-4'>
          <MapComponent
            onLocationSelect={(location) => {
              setFieldValue("address", location.address);
              setFieldValue("city", location.city);
              setFieldValue("state", location.state);
              setFieldValue("zipcode", location.zipcode);
              setFieldValue("latitude", location.lat.toString());
              setFieldValue("longitude", location.lng.toString());
            }}
            initialLat={Number(values.latitude) || undefined}
            initialLng={Number(values.longitude) || undefined}
          />
        </div>

    </Form>
  );
};

export default ClientForm;
